module.exports = __webpack_public_path__ + "static/media/pointsfeatures.62968d28.png";